import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
const navLinks = [{
  key: 'inicio',
  href: '#inicio'
}, {
  key: 'servicios',
  href: '#servicios'
}, {
  key: 'nosotros',
  href: '#nosotros'
}, {
  key: 'garantia',
  href: '#garantia'
}, {
  key: 'faq',
  href: '#faq'
}, {
  key: 'ubicacion',
  href: '#ubicacion'
}, {
  key: 'contacto',
  href: '#contacto'
}];
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const handleNavClick = () => {
    setMobileOpen(false);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-brand-gold/20" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="flex justify-between items-center h-16" data-id="element-152">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-153">
            <img src="https://cdn.magicpatterns.com/uploads/r65Do7snHotGvJ9xDGDVi3/heylloyd-image-1774744993354.png" alt="Benitez Handyman Construction Logo" className="h-14 w-auto object-contain rounded" data-id="element-154" />
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-1" data-id="element-155">
            {navLinks.map(link => <a key={link.href} href={link.href} className="px-3 py-2 text-sm font-heading font-medium text-gray-300 hover:text-brand-gold uppercase tracking-wider transition-colors duration-200" data-id="element-156">
                {t(`header.nav.${link.key}`)}
              </a>)}
          </nav>

          {/* Phone CTA + Mobile Toggle */}
          <div className="flex items-center gap-3" data-id="element-157">
            <div className="flex items-center bg-gray-900 rounded-full p-1 border border-gray-800" data-id="element-158">
              <button onClick={() => setLanguage('es')} className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${language === 'es' ? 'bg-brand-gold text-black' : 'text-gray-400 hover:text-white'}`} data-id="element-159">
                ES
              </button>
              <button onClick={() => setLanguage('en')} className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${language === 'en' ? 'bg-brand-gold text-black' : 'text-gray-400 hover:text-white'}`} data-id="element-160">
                EN
              </button>
            </div>

            <a href="https://wa.me/12029132653?text=Hola%2C%20quiero%20un%20estimado%20gratis" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 bg-[#25D366] hover:bg-[#1DA851] text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-md font-heading font-bold text-sm tracking-wide transition-colors duration-300 shadow-lg shadow-[#25D366]/20" data-id="element-161">
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-162">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-163" />
              </svg>
              <span className="hidden sm:inline text-lg" data-id="element-164">(202) 913-2653</span>
              <span className="sm:hidden text-base" data-id="element-165">
                {t('header.whatsapp')}
              </span>
            </a>

            {/* Hamburger Button */}
            <button onClick={() => setMobileOpen(!mobileOpen)} className="lg:hidden flex flex-col justify-center items-center w-10 h-10 gap-1.5 focus:outline-none" aria-label="Abrir menú" data-id="element-166">
              <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`} data-id="element-167"></span>
              <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? 'opacity-0' : ''}`} data-id="element-168"></span>
              <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`} data-id="element-169"></span>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-170">
        {mobileOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="lg:hidden bg-black border-t border-brand-gold/10 overflow-hidden" data-id="element-171">
            <nav className="flex flex-col py-4 px-6" data-id="element-172">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={handleNavClick} className="py-3 text-lg font-heading font-medium text-gray-300 hover:text-brand-gold uppercase tracking-wider transition-colors duration-200 border-b border-gray-800/50 last:border-0" data-id="element-173">
                  {t(`header.nav.${link.key}`)}
                </a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}